import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../lib/utils.js";
function Card({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card", className: cn('flex flex-col gap-5 rounded-2xl border border-border bg-card py-5 text-card-foreground shadow-sm', className), ...props }));
}
function CardHeader({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-header", className: cn('@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-5 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-5', className), ...props }));
}
function CardTitle({ className, ...props }) {
    return (_jsx("h3", { "data-slot": "card-title", className: cn('font-display text-xl leading-tight font-semibold text-foreground', className), ...props }));
}
function CardDescription({ className, ...props }) {
    return (_jsx("p", { "data-slot": "card-description", className: cn('text-sm text-muted-foreground', className), ...props }));
}
function CardAction({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-action", className: cn('col-start-2 row-span-2 row-start-1 self-start justify-self-end', className), ...props }));
}
function CardContent({ className, ...props }) {
    return _jsx("div", { "data-slot": "card-content", className: cn('px-5', className), ...props });
}
function CardFooter({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-footer", className: cn('flex items-center gap-3 px-5 [.border-t]:pt-5', className), ...props }));
}
export { Card, CardAction, CardContent, CardDescription, CardFooter, CardHeader, CardTitle };
//# sourceMappingURL=card.js.map